module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    ref: "navbar",
    staticClass: "navbar has-primary-background"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": '/'
    }
  }, [_c('figure', {
    staticClass: "image relative"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/fstatic/logo-text.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "absolute rotate",
    attrs: {
      "src": "/fstatic/spinner.svg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger",
    attrs: {
      "data-target": "navMenubd-example"
    },
    on: {
      "click": function($event) {
        _vm.menuIsActive = !_vm.menuIsActive
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), (_vm.menuIsActive) ? _c('div', [_c('mobile-navbar', {
    attrs: {
      "solutions": _vm.allSolutions,
      "capabilities": _vm.capabilities
    },
    on: {
      "clicked": function($event) {
        _vm.menuIsActive = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu has-primary-background",
    attrs: {
      "id": "navMenubd-example"
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('ul', [_c('li', {
    class: {
      'is-red': _vm.$route.path === '/'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t("navbar.home")) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-red': _vm.$route.path === '/about'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/about'
    }
  }, [_vm._v(" About Us ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-red': _vm.$route.name === 'capabilities'
    }
  }, [_c('dropdown', {
    attrs: {
      "route": "capabilities",
      "capabilities": true,
      "itemsObj": _vm.capabilities
    }
  })], 1), _vm._v(" "), _c('li', {
    class: {
      'is-red': _vm.$route.name === 'solutions'
    }
  }, [_c('dropdown', {
    attrs: {
      "route": "solutions",
      "solutions": true,
      "itemsObj": _vm.solutions
    }
  })], 1), _vm._v(" "), _c('li', {
    class: {
      'is-red': _vm.$route.path === '/careers'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/careers'
    }
  }, [_vm._v(" Careers ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-red': _vm.$route.path === '/contact'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/contact'
    }
  }, [_vm._v(" Contact Us ")])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f807c34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/header.vue
// module id = 1138
// module chunks = 1